import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useIsPRAdmin = (): boolean => {
  const [isPRAdmin, setIsPRAdmin] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  // Right now PR users/admins have only notes related permissions so
  // I'm using that. I think it would really make more sense to have
  // a specific permission for this but for now I will use this. It
  // sounds like this is a temporary thing anyway.
  const notesUpdatePermission: Permission = {
    resource: 'notes',
    action: 'updatebasic',
    scope: 'all',
  };

  const hasPRAdminPermission = useHasPermission(user, notesUpdatePermission);

  React.useEffect(() => {
    setIsPRAdmin(hasPRAdminPermission);
    // setIsPRAdmin(true); // TODO: remove this before checkin
  }, [hasPRAdminPermission]);

  return isPRAdmin;
};
